<ng-container *ngIf="menuItems$ | async as menuItems">
  <div
    *ngIf="menuItems.length"
    class="layout-breadcrumb-container flex justify-content-between align-items-center shadow-1"
  >
    <p-breadcrumb [home]="(homeLink$ | async)!" [model]="menuItems"></p-breadcrumb>
  </div>
</ng-container>
